<template>
  <div>
    <div class="css-grid pay-invoice-form__row pay-invoice-form__row--header pay-invoice-form__row--error">
      <div></div>
      <div class="pay-invoice-view__cell pay-invoice-view__cell--header">Payment Gateway Down</div>
      <div></div>
    </div>

    <div class="panel">
      <div class="css-grid pay-invoice-form__row">
        <div></div>
        <div class="pay-invoice__message h-center-align">
          The payment processing gateway is undergoing maintenance. Please contact the accounting department at accounting@fuelmedical.com to process your payment.
          <br><br>
          Apologies for any inconvenience this has caused. We're working diligently to resolve the matter.
        </div>
        <div></div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'OutOfOrderView',
  }
</script>
